/** Game tuning for Catch, Shout, Catch! gatherer / host falling zone. */
export const CATCH_SHOUT_CATCH_CONFIG = {
  fallSpeedPerSecond: 1.2,
  fallSpeedMultiplierMin: 0.75,
  fallSpeedMultiplierMax: 1.35,
  spawnIntervalMs: 650,
  spawnCountMax: 2,
  platformWidthFraction: 0.24,
  platformHeightPx: 28,
  emojiSizePx: 42,
  catchMarginFraction: 0.15,
  platformStripHeightPx: 70,
  fenceWidthPx: 6,
} as const;
